import React from "react";
import { GridLegacy as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import StatCard from "./StatCard";
import type { DriverShiftSummary } from "../hooks/useDriverSummary";

interface SummaryStatsProps {
  summary: Pick<DriverShiftSummary, "activeDriverCount" | "drivingCount" | "notDrivingCount">;
  isLoading?: boolean;
}

const SummaryStats: React.FC<SummaryStatsProps> = ({ summary, isLoading = false }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} sx={{ marginBottom: 3, justifyContent: "center" }}>
      <Grid item xs={12} sm={4} md={3}>
        <StatCard
          label={t("driverShiftTracker.summary.driversOnShift")}
          value={summary.activeDriverCount}
          isLoading={isLoading}
          data-testid="stat-card-drivers-on-shift"
        />
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
        <StatCard
          label={t("driverShiftTracker.summary.driving")}
          value={summary.drivingCount}
          isLoading={isLoading}
          data-testid="stat-card-driving"
        />
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
        <StatCard
          label={t("driverShiftTracker.summary.notDriving")}
          value={summary.notDrivingCount}
          isLoading={isLoading}
          data-testid="stat-card-not-driving"
        />
      </Grid>
    </Grid>
  );
};

export default SummaryStats;
